import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Alert } from "antd";
import { WifiOutlined, DatabaseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const InternetChecker = () => {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isHealthy, setIsHealthy] = useState(true);

  const handleOnline = useCallback(() => setIsOnline(true), []);
  const handleOffline = useCallback(() => setIsOnline(false), []);

  const checkHealth = useCallback(async () => {
    const apiUrl = process.env.REACT_APP_API_URL.replace("api/v1/", "");
    try {
      const response = await axios.get(`${apiUrl}health`);
      setIsHealthy(response.status === 200);
    } catch (error) {
      setIsHealthy(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (isOnline) {
      checkHealth();
    }

    const interval = setInterval(checkHealth, 60000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, [isOnline, handleOnline, handleOffline, checkHealth]);

  return (
    <>
      {!isOnline && (
        <Alert
          showIcon
          icon={<WifiOutlined />}
          style={{ position: "fixed", bottom: 50, left: "50%", transform: "translateX(-50%)", zIndex: 1000 }}
          type="error"
          message={t("common.noInternet")}
        />
      )}
      {isOnline && !isHealthy && (
        <Alert
          showIcon
          icon={<DatabaseOutlined />}
          style={{ position: "fixed", bottom: 50, left: "50%", transform: "translateX(-50%)", zIndex: 1000 }}
          type="error"
          message={t("common.serverUnhealthy")}
        />
      )}
    </>
  );
};

export default InternetChecker;
